<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="this.$t('userForOpenbadge.section1.texts.text1-1')"
            :sub-title="this.$t('userForOpenbadge.section1.texts.text1-2')"
            bg-color=""
        />

        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <v-row>
                    <v-col
                        cols="12"
                        md="11"
                        lg="10"
                        class="mx-auto position-relative"
                        :class="{
                            'd-flex align-start justify-space-between': $vuetify.breakpoint.mdAndUp,
                        }"
                    >
                        <!-- 발행자 로그인 -->
                        <div
                            style="flex: 1 1 50%;"
                            :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '384px' : '' }"
                            class="d-flex flex-column align-center justify-center"
                        >
                            <p 
                                class="le-heading4" 
                                :class="{
                                    'mb-6': $vuetify.breakpoint.mdAndUp,
                                    'mb-5': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                {{ this.$t('userForOpenbadge.section2.texts.text1-1') }}
                            </p>

                            <div>
                                <v-img
                                    :src="require('@/assets/img/user-for-openbadge-1.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 384 : ($vuetify.breakpoint.smOnly ? 360 : 300)"
                                    contain
                                    alt=""
                                />
                            </div>
                            
                            <p
                                class="le-text-body1 text-center"
                                :class="{
                                    'mt-10': $vuetify.breakpoint.mdAndUp,
                                    'mt-9': $vuetify.breakpoint.smOnly,
                                    'mt-6': $vuetify.breakpoint.xsOnly
                                }"
                            >
                                {{ this.$t('userForOpenbadge.section2.texts.text1-2') }}
                            </p>

                            <div
                                :class="{
                                    'mt-15': $vuetify.breakpoint.mdAndUp,
                                    'mt-12': $vuetify.breakpoint.smOnly,
                                    'mt-10': $vuetify.breakpoint.xsOnly
                                }"
                                class="d-flex gap-7"
                            >
                                <v-btn
                                    href="https://nlp.netlearning.co.jp/ns/login/LogIn.aspx?ReturnUrl=/ns/comsys/Default.aspx&lang=en"
                                    target="_blank"
                                    color="orange1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadge.section2.btns.btn1') }}
                                </v-btn>

                                <v-btn
                                    href="https://lecos.notion.site/b1cbcf01272049f1910984db79e92cbd"
                                    target="_blank"
                                    color="blue1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadge.section2.btns.btn2') }}
                                </v-btn>
                            </div>
                        </div>

                        <!-- 수령자 로그인 -->
                        <div
                            style="flex: 1 1 50%;"
                            :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '384px' : '' }"
                            class="d-flex flex-column align-center justify-center"
                            :class="{
                                'mt-22': $vuetify.breakpoint.smAndDown
                            }"
                        >
                            <p 
                                class="le-heading4" 
                                :class="{
                                    'mb-6': $vuetify.breakpoint.mdAndUp,
                                    'mb-5': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                {{ this.$t('userForOpenbadge.section2.texts.text2-1') }}
                            </p>

                            <div>
                                <v-img
                                    :src="require('@/assets/img/user-for-openbadge-2.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 384 : ($vuetify.breakpoint.smOnly ? 360 : 300)"
                                    alt=""
                                />
                            </div>
                            
                            <p
                                class="le-text-body1 text-center"
                                :class="{
                                    'mt-10': $vuetify.breakpoint.mdAndUp,
                                    'mt-9': $vuetify.breakpoint.smOnly,
                                    'mt-6': $vuetify.breakpoint.xsOnly
                                }"
                            >
                                {{ this.$t('userForOpenbadge.section2.texts.text2-2') }}
                            </p>

                            <div
                                :class="{
                                    'mt-15': $vuetify.breakpoint.mdAndUp,
                                    'mt-12': $vuetify.breakpoint.smOnly,
                                    'mt-10': $vuetify.breakpoint.xsOnly
                                }"
                                class="d-flex gap-7"
                            >
                                <v-btn
                                    href="https://www.openbadge-global.com/ns/portal/openbadge/login"
                                    target="_blank"
                                    color="orange1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadge.section2.btns.btn1') }}
                                </v-btn>

                                <v-btn
                                    href="https://lecos.notion.site/8755f872723b4027a1e678a1de3961a5"
                                    target="_blank"
                                    color="blue1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadge.section2.btns.btn3') }}
                                </v-btn>
                            </div>
                        </div>

                        <!-- ANCHOR: 다이얼로그-오픈배지 3.0 -->
                        <template>
                            <v-dialog
                                v-model="isOpenbadgeV3DialogVisible"
                                width="588"
                                content-class="custom-position"
                            >
                                <v-card class="pa-0 rounded-lg">
                                    <v-img
                                        :src="require('@/assets/img/user-for-openbadge-popup-invite-top.png')"
                                        contain
                                    ></v-img>

                                    <div class="le-heading5-5 pa-5">
                                        {{ this.$t('userForOpenbadge.modal.texts.text1') }}
                                    </div>

                                    <div
                                        class="pl-5 pr-6"
                                        style="min-height: 88px;"
                                    >
                                        <div class="le-text-subtitle2 mb-3">
                                            {{ this.$t('userForOpenbadge.modal.texts.text2') }}
                                        </div>

                                        <div
                                            class="le-text-body2"
                                            v-html="this.$t('userForOpenbadge.modal.texts.text3')"
                                        >
                                        </div>
                                    </div>

                                    <div class="pa-5 d-flex justify-end gap-3">
                                        <v-btn
                                            v-ripple="{ class: 'text-blue3' }"
                                            color="blue1"
                                            :small="$vuetify.breakpoint.smAndDown"
                                            depressed
                                            class="text-white1"
                                            outlined
                                            @click="isOpenbadgeV3DialogVisible = false"
                                        >
                                            {{ this.$t('userForOpenbadge.modal.btns.btn1') }}
                                        </v-btn>

                                        <v-btn
                                            :to="{ name: 'SampleBadgesV3Page' }"
                                            color="orange1"
                                            :small="$vuetify.breakpoint.smAndDown"
                                            depressed
                                            class="text-white1"
                                        >
                                            {{ this.$t('userForOpenbadge.modal.btns.btn2') }}
                                        </v-btn>
                                    </div>
                                </v-card>
                            </v-dialog>
                        </template>
                    </v-col>
                </v-row>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
// import { getLoginMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'AboutPage',
    components: {
        PageTitle
    },

    // metaInfo() {
    //     return getLoginMetaInfo(this);
    // },

    // SECTION: Data Properties
    data: function () {
        return {
            isOpenbadgeV3DialogVisible: true,
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    created() {
        //
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        /* ============================================================
         * ANCHOR: 주석
         * ============================================================ */
        //
    },
    // !SECTION: Methods
};
</script>
